"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.wrapRootElement = void 0;

var _react = _interopRequireDefault(require("react"));

var _appProviders = require("./components/app-providers");

/* eslint-disable import/no-extraneous-dependencies */

/* eslint-disable import/prefer-default-export */

/* eslint-disable react/prop-types */
var wrapRootElement = function wrapRootElement(_ref, pluginOptions) {
  var element = _ref.element;
  return /*#__PURE__*/_react.default.createElement(_appProviders.AppProviders, {
    element: element,
    pluginOptions: pluginOptions
  });
};

exports.wrapRootElement = wrapRootElement;